import React, { useState, useEffect } from 'react';
import app from '~/app';
import { log } from '@swiper/core';
import { Loading, ErrorBox, Markdown, PropTypes } from '~/utils';
import { Card, CardBody, CardHeader, CardFooter } from 'reactstrap';

export function InfoBlock( { id, snippet, bare, ...props } ) {
  if ( snippet && ! id ) id = `_snippets/${snippet}`;
  const [ data, setData ] = useState( null );
  const [ error, setError ] = useState( null );

  useEffect( () => {
    app.service( '/api/info' ).get( id ).then( setData ).catch( setError );
  }, [ id ] );

  if ( error ) return <ErrorBox error={error} />;
  if ( ! data ) return <Loading />;

  log.debug( '[InfoBlock] DATA', data );
  const { content, ...meta } = data;

  if ( bare ) return <Markdown content={content} />;

  return (
    <Card>
      <CardHeader tag="h3">{meta.title}</CardHeader>
      <CardBody><Markdown content={content} /></CardBody>
      <CardFooter>
      </CardFooter>
    </Card>
  );
}
InfoBlock.propTypes = {
  id      : PropTypes.string,
  snippet : PropTypes.string,
  bare    : PropTypes.bool,
};
InfoBlock.defaultProps = {
  bare    : false,
};
